import { Branch } from "../model/Branch";
import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("WorldAssignment.BranchesXMLParser");

export class BranchesXMLParser {

    public static parse(data: string): Array<Branch> {
        let parser = new DOMParser();
        let doc: Document = parser.parseFromString(data, "text/xml");
        let branches: Branch[] = [];
        let branch: Branch;
        let branchesElement: Element = doc.querySelector("branches");

        if (!branchesElement) {
            logger.debug("node 'branches' not found");
            return [];
        }

        if (branchesElement.children && branchesElement.children.length) {
            for (let i = 0; i < branchesElement.children.length; i++) {
                branch = this.parseBranch(branchesElement.children.item(i));
                branches.push(branch);
            }
        } else {
            logger.debug("node 'branches' is null or empty");
        }

        return branches;
    }

    private static parseBranch(element: Element): Branch {
        let id: string = element.attributes.getNamedItem("id").textContent;
        let version: string = element.attributes.getNamedItem("version").textContent;
        let zones: string[] = this.parseZones(element.querySelector("zones"));

        return new Branch(id, version, zones);
    }

    private static parseZones(element: Element) {
        let zones: string[] = [];
        if (element) {
            for (let i = 0; i < element.children.length; i++) {
                zones.push(element.children.item(i).textContent);
            }
        }

        return zones;
    }
}
